export const PERMISSION_CATEGORIES = {
  'Content Management': [
    'view_questions',
    'create_questions',
    'edit_own_questions',
    'edit_all_questions',
    'delete_questions',
    'upload_pdf',
    'validate_chunks',
    'approve_questions',
  ],
  'Compliance': [
    'compliance_review',
    'manage_regulations',
    'view_audit_logs',
  ],
  'Testing': [
    'take_tests',
    'generate_tests',
  ],
  'Analytics & Reporting': [
    'view_analytics',
    'export_analytics',
  ],
  'AI & Agent System': [
    'view_agent_traces',
    'manage_mcp_servers',
    'debug_agents',
    'configure_pipeline',
    'view_cost_metrics',
  ],
  'Administration': [
    'manage_users',
    'system_config',
    'manage_system',
  ],
};

export const PERMISSION_LABELS: Record<string, string> = {
  'view_questions': 'View Questions',
  'create_questions': 'Create Questions',
  'edit_own_questions': 'Edit Own Questions',
  'edit_all_questions': 'Edit All Questions',
  'delete_questions': 'Delete Questions',
  'upload_pdf': 'Upload PDF',
  'validate_chunks': 'Validate Chunks',
  'approve_questions': 'Approve Questions',
  'compliance_review': 'Compliance Review',
  'manage_regulations': 'Manage Regulations',
  'view_audit_logs': 'View Audit Logs',
  'take_tests': 'Take Tests',
  'generate_tests': 'Generate Tests',
  'view_analytics': 'View Analytics',
  'export_analytics': 'Export Analytics',
  'view_agent_traces': 'View Agent Traces',
  'manage_mcp_servers': 'Manage MCP Servers',
  'debug_agents': 'Debug Agents',
  'configure_pipeline': 'Configure Pipeline',
  'view_cost_metrics': 'View Cost Metrics',
  'manage_users': 'Manage Users',
  'system_config': 'System Configuration',
  'manage_system': 'Manage System',
};
